import { render } from "./FormInterval.vue?vue&type=template&id=20bc7138&scoped=true"
import script from "./FormInterval.vue?vue&type=script&lang=js"
export * from "./FormInterval.vue?vue&type=script&lang=js"

import "./FormInterval.vue?vue&type=style&index=0&id=20bc7138&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bc7138"]])

export default __exports__